import * as Yup from "yup";

interface AddPostal extends Yup.MixedSchema {
  PostalCode: string;
  SelectedMunicipalityName: string;
  PostalPlace: string;
  SelectedMunicipalityCode: string;
  CityAreaNo: string;
  systemCountryCode: string;
}

export const validationSchema = Yup.object<AddPostal>().shape({
  countryCode: Yup.string()
    .required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    )
    .typeError(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
    ),
  systemCountryCode: Yup.string(),
  postalCode: Yup.string()
    .when(["countryCode", "systemCountryCode"], {
      is: (countryCode: string, systemCountryCode: string) => countryCode === systemCountryCode,
      then: Yup.string().matches(/^\d+$/, "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"),
      otherwise: Yup.string(),
    })
    .required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    )
    .typeError(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
    ),
  postalPlace: Yup.string()
    .required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    )
    .test(
      "postalPlaceDigit",
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
      (val: any) => {
        let value = typeof val == "undefined" ? "" : val;
        return !/^\d+$/.test(value);
      }
    ),
  municipalityName: Yup.string()
    .required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    ),
});
